import React from 'react';
import { FJ180 } from '../../../services/j209Api';
import LookupField from '../../../components/LookupField';

interface Tab1HeaderProps {
  formData: Partial<FJ180>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof FJ180) => FJ180[keyof FJ180];
  setField: (key: keyof FJ180, value: FJ180[keyof FJ180]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
}

const dateToInput = (v: string | null | undefined): string => v ? String(v).substring(0, 10) : '';
const inputToDate = (v: string): string | null => v ? v + 'T00:00:00Z' : null;

const Tab1Header: React.FC<Tab1HeaderProps> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName,
}) => (
  <div className="form-grid">
    <label>繳庫單號</label>
    <div>
      <input value={String(getField('fj180_01') || '')} disabled style={{ width: 120 }} />
    </div>

    <label>繳庫日期</label>
    <div>
      <input
        type="date"
        value={dateToInput(getField('fj180_11') as string | null)}
        onChange={e => setField('fj180_11', inputToDate(e.target.value) as unknown as FJ180[keyof FJ180])}
        disabled={!isEditing}
        style={{ width: 150 }}
      />
    </div>

    <label>繳庫庫位</label>
    <div className="lookup-field">
      <LookupField
        lookupType="warehouse"
        value={String(getField('fj180_15') || '')}
        onChange={v => setField('fj180_15', v as unknown as FJ180[keyof FJ180])}
        onCodeConfirm={code => resolveSingleName('warehouse', 'warehouse', code)}
        disabled={!isEditing}
        style={{ width: 100 }}
        maxLength={5}
      />
      <span className="lookup-name">{names.warehouse || ''}</span>
    </div>

    <label>入單人員</label>
    <div className="lookup-field">
      <input value={String(getField('fj180_17') || '')} disabled style={{ width: 100 }} />
      <span className="lookup-name">{names.employee || ''}</span>
    </div>

    <label>部門</label>
    <div className="lookup-field">
      <input value={String(getField('fj180_16') || '')} disabled style={{ width: 80 }} />
      <span className="lookup-name">{names.department || ''}</span>
    </div>

    <label>總項次</label>
    <div>
      <input value={String(formData.fj180_18 ?? 0)} disabled style={{ width: 60 }} />
    </div>
  </div>
));

Tab1Header.displayName = 'Tab1Header';
export default Tab1Header;
